import { Pipe, PipeTransform } from '@angular/core';

import { TerraStatusBadgeColor } from '@ninety/terra';

import { DiscussionListItem, DiscussionModel } from '../models/discussion.models';

@Pipe({
  name: 'discussionStatus',
})
export class DiscussionStatusPipe implements PipeTransform {
  transform(discussion: DiscussionListItem | DiscussionModel): string {
    if (discussion.isManagerDone && discussion.isManageeDone) return 'Complete';

    if (discussion.dueDate) {
      const due = new Date(discussion.dueDate);
      if (due < new Date()) return 'Not Complete';
    }

    return 'In Progress';
  }
}

@Pipe({
  name: 'discussionStatusSeverity',
})
export class DiscussionStatusSeverityPipe implements PipeTransform {
  transform(discussion: DiscussionListItem | DiscussionModel): TerraStatusBadgeColor {
    const isComplete = discussion.isManagerDone && discussion.isManageeDone;
    return isComplete ? 'success' : 'neutral';
  }
}
